
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/floating-video.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useCallback } from 'react';
import { useRoom } from '@hooks/useRoom';
import { Participant, useParticipants, VideoColumn, VideoControls, VideoRow } from '@components/Video/SimpleVideo';
import { useRouter } from 'next/router';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import assert from 'assert';

interface FloatingVideoProps {
  roomName: string;
  secondaryToken: string;
  excludeTrack: string;
}
export const FullScreenView = ({ roomName, secondaryToken, excludeTrack }: FloatingVideoProps) => {
  const { appointment } = useSessionAppointment();
  const { room } = useRoom(roomName, secondaryToken, appointment, false);
  const { remoteParticipants, localParticipant } = useParticipants(room);

  const RemoteParticipantView = useCallback(
    () => (
      <>
        {remoteParticipants
          .filter((p) => p.sid !== excludeTrack)
          .map((p) => (
            <Participant
              key={p.sid}
              participant={p}
              showPreview={false}
              hideVideoPreview={false}
              repositionModeEnabled={false}
              showPreviewPositions={false}
              hidePreviewPositions={false}
            />
          ))}
      </>
    ),
    [remoteParticipants, excludeTrack]
  );

  return (
    <VideoColumn>
      <VideoRow>
        <RemoteParticipantView />
      </VideoRow>
      <VideoRow>
        <VideoControls
          fullPage
          fullScreen
          room={room}
          handleFullscreenRequest={false}
          onRequestPopout={() => {}}
          localParticipant={localParticipant}
          signalQualityChanged={() => {}}
        />
      </VideoRow>
    </VideoColumn>
  );
};

export function FloatingVideo() {
  const { query } = useRouter();
  const { roomName, secondaryToken, excludeTrack } = query;

  if (!roomName || !secondaryToken) {
    return null;
  }

  assert(!Array.isArray(roomName) && roomName, 'Room name was expected to be passed as a single value query param');
  assert(
    !Array.isArray(secondaryToken),
    'secondaryToken was expected to be passed as an (optional) single value query param'
  );
  assert(
    !Array.isArray(excludeTrack),
    'excludeTrack was expected to be passed as an (optional) single value query param'
  );

  return <FullScreenView roomName={roomName} secondaryToken={secondaryToken} excludeTrack={excludeTrack || ''} />;
}

export default FloatingVideo;
export const Route = createFileRoute('/floating-video')({ component: FloatingVideo });
